module.exports = __webpack_public_path__ + "media/images/favicons/safari-pinned-tab-cc712f3b3b68fa04f94f6a7e7ab01211.svg";